import { Suspense, useState } from 'react'
import { BaseModal } from './_BaseModal'
import { Button } from 'components/atoms/buttons/Button'
import { updateMemo } from 'api/memo/updateMemo'
import swal from 'sweetalert2'
import { classNames } from 'utils/classNames'
import { useSelectMemo } from 'api/memo/useSelectMemo'
import { LoadingOverlay } from 'components/atoms/overlay/LoadingOverlay'

type Props = {
  companyId: number
  onClose: () => void
  onUpdate: () => void
}
export const MemoModal = (props: Props): JSX.Element | null => {
  const { companyId, onClose, onUpdate } = props
  const { data, mutate } = useSelectMemo(companyId)
  const [localText, setLocalText] = useState<string>('')
  const memoUpdateHandler = async () => {
    if (data) {
      const requestParams = {
        companyId: data.id,
        version: data.version,
        memo: localText
      }
      await updateMemo(requestParams)
        .then(() => {
          swal
            .fire({
              icon: 'info',
              text: 'メモを更新しました。',
              confirmButtonText: 'OK'
            })
            .then((result) => {
              if (result.isConfirmed) {
                setLocalText('')
                mutate({ data: { ...data, memo: localText } })
                onUpdate()
              } else {
                return
              }
            })
        })
        .catch((error: any) => {
          swal.fire({
            icon: 'error',
            text: error?.data?.message || 'メモの更新に失敗しました。',
            confirmButtonText: 'OK'
          })
        })
    }
  }
  const keyDownHandler = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      memoUpdateHandler()
    }
  }
  const outlineNoneStyle = 'outline-none focus:outline-none'
  const commonTextAreaStyle =
    'block resize-none p-2 w-full text-sm text-gray-900 rounded-lg h-80 outline-1 outline-gray-300'

  return (
    <BaseModal style={'w-[700px]'}>
      <Suspense fallback={<LoadingOverlay />}>
        {data && (
          <div className="space-y-4">
            <div className={'truncate'}>{'会社名：' + data.name}</div>
            <textarea
              value={localText}
              onChange={(event) => {
                setLocalText(event.target.value)
              }}
              className={classNames([
                outlineNoneStyle,
                commonTextAreaStyle,
                'focus:outline-2 focus:outline-blue-200'
              ])}
              placeholder={'先方担当者：\n注力情報：\n業界：'}
              onKeyDown={keyDownHandler}
            />
            <textarea
              value={data.memo}
              className={classNames([
                outlineNoneStyle,
                commonTextAreaStyle,
                'disabled:text-gray-600'
              ])}
              disabled
            />
            <div className={'flex justify-around'}>
              <div className={'w-40'}>
                <Button
                  clickHandler={memoUpdateHandler}
                  label={'更新'}
                  disabled={!localText}
                />
              </div>
              <div className={'w-40'}>
                <Button clickHandler={onClose} label={'閉じる'} />
              </div>
            </div>
          </div>
        )}
      </Suspense>
    </BaseModal>
  )
}
